export function toCents(dollars) {
  return Math.round(dollars.replace('$', '') * 100);
}

export function toDollars(cents) {
  return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export function validateEmail(email) {
  if(!email || emailRegex.test(email) === false){
    return false;
  }

  return true;
}
